<div class="gis-auth-error-container">
  <mat-card class="error-card">
    <mat-card-header>
      <mat-card-title>GIS Authentication Failed</mat-card-title>
      <mat-card-subtitle>Unable to connect to the GIS Portal ({{ portalUrl }})</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <p class="error-description">This could be due to:</p>

      <ul class="error-reasons">
        <li>The GIS Portal service is temporarily unavailable</li>
        <li>Network connectivity issues</li>
        <li>Your session expired or authentication was cancelled</li>
        <li>Portal configuration issues</li>
      </ul>

      <p class="retry-note">
        Please try again. If the problem persists, contact support.
      </p>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="retryAuthentication()">
        Try Again
      </button>
    </mat-card-actions>

    <mat-divider></mat-divider>

    <div class="support-section">
      <p class="support-text">Need help? Contact support at:</p>
      <a [href]="'mailto:' + supportEmail" class="support-email">{{ supportEmail }}</a>
    </div>
  </mat-card>
</div>
